module.exports = __webpack_public_path__ + "static/media/apparel2.fb89e0c2.jpg";